export const casualPageConfig = {
  "pageShowType": "mobile",
  "title": "Date Comparison",
  "titleCN": "时间对比",
  "path": "/comparisonAnalysis/dateComparison",
  "defaultTab": "dateComparison",
  "tabList": [
    {
      "id": "dateComparison",
      "tabName": "Date Comparison",
      "tabNameCN": "时间对比",
      "isHaveNotification": true,
      "notificationPath": "/comparisonAnalysis/dateComparison",
      "path": "/comparisonAnalysis/dateComparison",
      "tabIcon": "",
      "logConfig": {
        "pageId": "201701",
        "pageName": "comparisonAnalysisDateComparison",
        "extInfo": "comparisonAnalysisDateComparison",
        "pagePath": "/comparisonAnalysis/dateComparison"
      },
      "filters": [
        {
          "data": {
            "reqMetrics": {
              "Day": [
                "total_users",
                "new_users",
                "active_users",
                "iaa_revenue",
                "ecpm",
                "cpi",
                "ug_install",
                "af_cpi",
                "new_ch_organic_rate",
                "fraud_active_users_rate",
                "spend",
                "roi",
                "register_arpu",
                "arpu",
                "d2",
                "d3",
                "d4",
                "d5",
                "d6",
                "d7",
                "d14",
                "d30",
                "roas1",
                "roas2",
                "roas3",
                "roas7",
                "roas14",
                "roas30",
                "roas60",
                "roas90",
                "roas120",
                "roas180",
                "iaa_impressions",
                "avg_active_user_matches",
                "avg_new_user_matches",
                "aot",
                "new_aot",
                "retention_users",
                "churn_users",
                "churn_rate",
                "return_users",
                "weighted_d2",
                "weighted_d3",
                "weighted_d7",
                "first_login_ratio",
                "second_login_ratio"
              ]
            },
            "filterTypeList": ["date"]
          },
          "name": "DateFilter",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "/comparisonAnalysis/dateComparison",
          "componentList": [
            {
              "name": "MetricInfo",
              "children": [
                {
                  "name": "dateComparisonTrendService",
                  "className": "",
                  "type": "view",
                  "style": {},
                  "props": {
                    "config": {
                      "api": "/api/v1/dashboard/comparison_analysis/date/linechart",
                      "isDark": true
                    }
                  },
                  "children": [
                    {
                      "name": "MetricComponent",
                      "path": "comparisonAnalysis/dateComparison",
                      "componentKey": "SegmentMoreCo",
                      "height": 41,
                      "className": "margin-t-20",
                      "config": {
                        "children": [
                          {
                            "name": "MetricComponent",
                            "path": "comparisonAnalysis/dateComparison",
                            "componentKey": "DateComparisonMetricsTrend",
                            "height": 757,
                            "className": "margin-t-20",
                          }
                        ]
                      }
                    }
                  ]
                },
                {
                  "name": "MetricComponent",
                  "path": "comparisonAnalysis/dateComparison",
                  "componentKey": "ComparisonTableCo",
                  "height": 775,
                  "className": "margin-t-20",
                  "props": {
                    "config": {
                      "api": {
                        "tableApi": "/api/v1/dashboard/comparison_analysis/date/overall_performance",
                        "tableDownloadApi": "/api/v1/dashboard/comparison_analysis/date/overall_performance/download"
                      },
                      "dataKey": "date_comparison",
                      "hasReqMetrics": true
                    }
                  }
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
